<template>
  <div class="content-page" @click="resetPopVisible">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-select
            v-model="phoneNumber"
            @change="selVip"
            @clear="clearVip"
            filterable
            clearable
            placeholder="请输入会员手机号"
            :filter-method="remoteMethod"
            :loading="loading"
            size="small"
            ref="checkVip"
          >
            <el-option
              v-for="item in vipList"
              :key="item.shopMemberId"
              :label="item.fullName"
              :value="item.customerUserId"
            >
            </el-option>
          </el-select>
          <div class="vip-info" v-if="mapVipList[customerUserId]">
            <img
              class="head-logo"
              :src="mapVipList[customerUserId].headLogo"
              alt=""
            />
            {{ mapVipList[customerUserId].fullName }}&nbsp;{{
              mapVipList[customerUserId].phoneNum
            }}&nbsp;编号{{ mapVipList[customerUserId].code }}
            <i class="el-icon-error" @click="clearVip"></i>
          </div>
        </div>
        <div class="header-right">
          <el-badge :value="hangingOrderUnpayList.length" class="hanging-btn">
            <el-button
              type="primary"
              icon="el-icon-tickets"
              size="small"
              @click="isShowHangingOrder = true"
              >取单</el-button
            >
          </el-badge>
          <el-button type="danger" size="small" @click="linkTo('/')"
            >关闭</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="main" v-loading="isLoad">
          <div class="project-content">
            <div class="project-header" v-if="mapVipList[customerUserId]">
              <div class="action-type">
                <div
                  class="item"
                  :class="{
                    active: actionType == item.value,
                  }"
                  v-for="item in actionTypes"
                  :key="item.value"
                  @click="actionType = item.value"
                >
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="project-body">
              <div class="equity-card" v-if="actionType == 'equityCard'">
                <div class="tabs">
                  <div
                    v-for="(item, index) in tabsList"
                    :key="index"
                    class="tabs-item"
                    :class="{ active: cardType == item.value }"
                    @click="change(item.value)"
                  >
                    {{ item.label }}
                  </div>
                </div>
                <div class="card-List">
                  <div
                    class="card-box"
                    v-for="item in cardType == 1 ? card1List : card2List"
                    :key="item.shopMemberCardId"
                    @click="addEquityCard(item)"
                  >
                    <div
                      class="card-item"
                      :style="{
                        background: `linear-gradient(to bottom right, ${cardColorObj[
                          item.bg || cardColorArr[0].bg
                        ] &&
                          cardColorObj[item.bg || cardColorArr[0].bg]
                            .startValue}, ${cardColorObj[
                          item.bg || cardColorArr[0].bg
                        ] &&
                          cardColorObj[item.bg || cardColorArr[0].bg]
                            .endValue})`,
                      }"
                    >
                      <img
                        class="card-bg"
                        src="@/assets/img/vip/pattern.png"
                        alt
                      />
                      <span
                        class="card-name"
                        :style="{
                          color: `${cardColorObj[
                            item.bg || cardColorArr[0].bg
                          ] &&
                            cardColorObj[item.bg || cardColorArr[0].bg]
                              .textColor}`,
                        }"
                        >{{ item.cardName }}</span
                      >
                      <span class="price">￥{{ item.price }}</span>
                      <span class="discount" v-show="item.cardType == 2"
                        >{{ item.times }}次</span
                      >
                      <!-- <span class="sale"
                        >库存：{{ item.total - item.sold }}</span
                      > -->
                    </div>
                  </div>
                  <div
                    class="list-none"
                    v-if="!(cardType == 1 ? card1List : card2List).length"
                  >
                    <img src="@/assets/img/common/list-none.png" alt />
                    <p>暂无数据</p>
                  </div>
                </div>
              </div>
              <div class="vip-card-info" v-if="actionType == 'recharge'">
                <div
                  class="card-item"
                  :style="{
                    background: `linear-gradient(to bottom right, ${
                      mapVipList[customerUserId].startValue
                    }, ${mapVipList[customerUserId].endValue})`,
                  }"
                >
                  <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
                  <span
                    class="card-name"
                    :style="{
                      color: `${mapVipList[customerUserId].textColor}`,
                    }"
                    >{{ mapVipList[customerUserId].cardName }}</span
                  >
                  <span class="tips">{{
                    mapVipList[customerUserId].cardSlogan
                  }}</span>
                  <span class="discount"
                    >{{
                      (mapVipList[customerUserId].discount * 100) / 10
                    }}折</span
                  >
                  <span class="wallet"
                    >余额：{{ mapVipList[customerUserId].wallet }}</span
                  >
                  <span class="score"
                    >积分：{{ mapVipList[customerUserId].score }}</span
                  >
                </div>
              </div>
              <div class="service-content" v-if="actionType == 'openOrder'">
                <div class="service-header">
                  <el-input
                    placeholder="请输入服务..."
                    v-model.trim="searchInput"
                    class="input-search"
                    size="small"
                    @keyup.enter.native="getFindAllGoodsPlus"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="getFindAllGoodsPlus"
                    ></el-button>
                  </el-input>
                </div>
                <div class="service-body">
                  <ol class="goods-classify-list" v-if="!isShowSearch">
                    <li
                      v-for="item in menuList"
                      :key="item.categoryName"
                      :class="menuSel == item.goodsCategoryId ? 'active' : ''"
                      @click="menuSel = item.goodsCategoryId"
                    >
                      {{ item.categoryName }}
                    </li>
                  </ol>
                  <div class="goods-list">
                    <div class="search-header" v-if="isShowSearch">
                      {{ goodsList.length }}个搜索结果
                      <el-link
                        type="primary"
                        :underline="false"
                        @click="resetSearch"
                        >返回</el-link
                      >
                    </div>
                    <div class="list" v-if="goodsList.length">
                      <el-badge
                        :value="item.selNum"
                        :hidden="!item.selNum"
                        v-for="(item, index) in goodsList"
                        :key="index"
                      >
                        <div class="item" @click="openDialog(index)">
                          <div class="tag-list">
                            <span v-if="item.unitType == 2">计重</span>
                          </div>
                          <img class="pic" :src="item.goodsImage" alt />
                          <div class="info">
                            <p class="title">{{ item.goodsName }}</p>
                            <p class="price">￥{{ item.retailPrice }}</p>
                          </div>
                        </div>
                      </el-badge>
                    </div>
                    <div v-else>
                      <div class="list-none">
                        <img src="@/assets/img/common/list-none.png" alt />
                        <p>暂无更多服务</p>
                        <el-button
                          type="primary"
                          size="small"
                          @click="linkTo('/service/edit')"
                          v-if="shopIsMaster"
                          >新建服务</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="order-action">
            <div class="content-container" v-if="actionType == 'recharge'">
              <div class="recharge-form">
                <div class="recharge-item">
                  <div class="title-text">充值金额：</div>

                  <el-input
                    class="value-input"
                    v-model="rechargeValue"
                    size="small"
                    @input.native="rechargeValueInput"
                    placeholder="请输入充值金额"
                  >
                  </el-input>
                </div>
                <div class="recharge-item">
                  <div class="title-text">销售：</div>
                  <el-select
                    v-model="selRechargeSale"
                    placeholder="请选择"
                    size="small"
                  >
                    <el-option
                      v-for="item in artisansList"
                      :key="item.workUserId"
                      :label="`${item.nickName}`"
                      :value="item.workUserId"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="activity-list">
                  <el-button
                    type="primary"
                    size="small"
                    v-for="(item, index) in activityList"
                    :key="index"
                    @click="rechargeValue = item.rechargeMoney"
                    >充{{ item.rechargeMoney }}送{{
                      item.handselMoney
                    }}</el-button
                  >
                </div>
              </div>
            </div>
            <div class="content-container" v-if="actionType == 'equityCard'">
              <div class="top">
                <span class="title">消费明细</span>
                <el-button type="text" @click="clearEquityCardList"
                  >清空</el-button
                >
              </div>
              <div class="product-list">
                <div
                  class="item"
                  v-for="(item, index) in equityCardList"
                  :key="`${item.goodsId}${item.specDesc}`"
                >
                  <div
                    class="service-info"
                    style="box-shadow: none;align-items: center;"
                  >
                    <div class="info">
                      <p class="name">{{ item.cardName }}</p>
                    </div>
                    <div class="num">
                      1
                    </div>
                    <div class="price">
                      <div class="total">
                        ￥{{ ((item.vipPrice || item.price) * 1).toFixed(2) }}
                      </div>
                    </div>
                  </div>
                  <div class="service-personal">
                    <div class="nickname" v-if="item.saleUserIds">
                      销售：{{ mapArtisansList[item.saleUserIds].nickName }}
                    </div>
                    <div
                      class="add-personal"
                      @click="showSelPersonal(item, index)"
                    >
                      <i class="el-icon-plus"></i>
                      <span v-if="!item.saleUserIds">销售</span>
                    </div>
                  </div>
                  <img
                    class="close"
                    src="../assets/img/icon-close-dark.png"
                    alt=""
                    @click="clearEquityCardList"
                  />
                </div>
              </div>
            </div>
            <div
              class="content-container"
              v-if="actionType == 'openOrder'"
              :class="{
                mask: !isFold,
              }"
            >
              <div class="top">
                <span class="title">消费明细（{{ productsList.length }}）</span>
                <el-button type="text" @click="clearProductsList"
                  >清空</el-button
                >
              </div>
              <div class="product-list">
                <div
                  class="item"
                  v-for="(item, index) in productsList"
                  :key="`${item.goodsId}${item.specDesc}`"
                >
                  <div class="service-info">
                    <div class="info">
                      <p class="name">{{ item.goodsName }}</p>
                      <p class="spec">{{ item.specDesc }}</p>
                    </div>
                    <div class="num">
                      <el-input-number
                        size="small"
                        v-model="item.buyCount"
                        :min="0"
                        :step="1"
                        @change="productNumChange($event, index)"
                      ></el-input-number>
                    </div>
                    <div class="price">
                      <div class="total">
                        ￥{{ (item.customPrice * item.buyCount).toFixed(2) }}
                        <el-button
                          class="cp-btn"
                          :class="`cp-btn${index}`"
                          type="text"
                          size="small"
                          v-popover:changePrice
                          @click.stop="showChangePrice(index)"
                          >改价</el-button
                        >
                      </div>
                      <div
                        class="discount"
                        v-if="
                          (mapVipList[customerUserId]
                            ? item.memberPrice
                            : item.turnoverPrice) *
                            item.buyCount !=
                            item.customPrice * item.buyCount
                        "
                      >
                        <span class="original"
                          >原价：￥{{
                            (
                              (mapVipList[customerUserId]
                                ? item.memberPrice
                                : item.turnoverPrice) * item.buyCount
                            ).toFixed(2)
                          }}</span
                        >
                        <span class="reduction"
                          >{{
                            (mapVipList[customerUserId]
                              ? item.memberPrice
                              : item.turnoverPrice) *
                              item.buyCount >
                            item.customPrice * item.buyCount
                              ? "-"
                              : "+"
                          }}
                          ￥{{
                            Math.abs(
                              item.customPrice * item.buyCount -
                                (mapVipList[customerUserId]
                                  ? item.memberPrice
                                  : item.turnoverPrice) *
                                  item.buyCount
                            ).toFixed(2)
                          }}</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="service-personal">
                    <div class="nickname" v-if="item.workUserIds">
                      手艺人：{{ mapArtisansList[item.workUserIds].nickName }}
                    </div>
                    <div class="nickname" v-if="item.saleUserIds">
                      销售：{{ mapArtisansList[item.saleUserIds].nickName }}
                    </div>
                    <div
                      class="add-personal"
                      @click="showSelPersonal(item, index)"
                    >
                      <i class="el-icon-plus"></i>
                      <span v-if="!item.saleUserIds && !item.workUserIds"
                        >手艺人/销售</span
                      >
                    </div>
                  </div>
                  <img
                    class="close"
                    src="../assets/img/icon-close-dark.png"
                    alt=""
                    @click="delProducts(index)"
                  />
                </div>
              </div>
            </div>
            <div class="footer">
              <div
                class="fold-container"
                v-if="actionType == 'openOrder' || actionType == 'equityCard'"
              >
                <div class="title">
                  订单详情
                  <el-button type="text" size="mini" @click="isFold = !isFold"
                    >{{ isFold ? "展开" : "折叠"
                    }}<i
                      :class="{
                        'el-icon-arrow-up': isFold,
                        'el-icon-arrow-down': !isFold,
                      }"
                    ></i
                  ></el-button>
                </div>
                <div class="content">
                  <div class="more-col">
                    <div
                      class="item center"
                      v-if="productsList.length || equityCardList.length"
                    >
                      <div class="title-text">
                        补单
                        <el-popover
                          placement="top-bottom"
                          title=""
                          width="200"
                          trigger="hover"
                          content="1.补单多用于补开历史订单，支持补录59天内的订单。2.使用补单后该笔订单的相关营收将计入补录的时间。"
                        >
                          <i slot="reference" class="el-icon-question"></i>
                        </el-popover>
                      </div>
                      <el-switch v-model="isSupplement"> </el-switch>
                      <el-date-picker
                        size="small"
                        :picker-options="timeOption"
                        v-if="isSupplement"
                        v-model="supplementDate"
                        type="datetime"
                        placeholder="选择日期时间"
                      >
                      </el-date-picker>
                    </div>
                    <div class="item" v-if="actionType != 'equityCard'">
                      <div class="title-text">
                        手牌:
                      </div>
                      <div class="hand-cards">
                        <div
                          class="card"
                          :key="index"
                          v-for="(item, index) in handCards"
                        >
                          <el-input
                            class="input-new-tag"
                            v-if="item.attrValueInputVisible"
                            v-model="item.card"
                            :ref="`saveTagInput${index}`"
                            size="small"
                            @keyup.enter.native="
                              handleAttrValueInputConfirm(index)
                            "
                            @blur="handleAttrValueInputConfirm(index)"
                          ></el-input>
                          <el-tag
                            v-else
                            closable
                            :disable-transitions="true"
                            @click="tagClick(index)"
                            @close="handleClose(index)"
                            >{{ item.card }}</el-tag
                          >
                        </div>
                        <el-button
                          class="button-new-tag"
                          size="small"
                          @click="addHandCard"
                          >+ 添加</el-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="more-col" style="margin: 10px 0" v-if="!isFold">
                    <div class="item">
                      <div class="title-text">批量添加:</div>
                      <div class="add-personal" @click="batchSelPersonal">
                        <i class="el-icon-plus"></i>
                        <span>{{
                          actionType != "equityCard" ? "手艺人/销售" : "销售"
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="item"
                      v-if="customerUserId && actionType != 'equityCard'"
                    >
                      <div class="title-text">优惠券:</div>
                      <el-select
                        v-model="selCashCoupon"
                        placeholder="请选择"
                        size="small"
                        clearable
                      >
                        <el-option
                          v-for="item in userCashCoupons.filter((val) => {
                            return (
                              (val.minUsePrice <= noCashCouponMoney &&
                                +new Date(val.expireDay) >= +new Date() &&
                                (val.usedStatus == 1 || val.usedStatus == 3)) ||
                              (selCashCoupon &&
                                selCashCoupon == val.cashCouponId)
                            );
                          })"
                          :key="item.cashCouponId"
                          :label="
                            `${item.title}(满${item.minUsePrice}减${
                              item.price
                            })`
                          "
                          :value="item.cashCouponId"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="item" v-if="!isFold">
                    <div class="title-text">备注:</div>
                    <el-input
                      class="remarks-input"
                      type="textarea"
                      rows="5"
                      placeholder="请输入备注"
                      v-model="remarks"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="action-btn">
                <div class="left" v-if="actionType == 'equityCard'">
                  待收款:<span class="price"
                    >￥{{ Number(equityCardTotalMoney).toFixed(2) }}</span
                  >
                </div>
                <div class="left" v-if="actionType == 'recharge'">
                  待收款:<span class="price"
                    >￥{{ Number(rechargeValue).toFixed(2) }}</span
                  >
                </div>
                <div class="left" v-if="actionType == 'openOrder'">
                  待收款:<span class="price"
                    >￥{{ totalMoney.toFixed(2) }}</span
                  >
                  <span class="discount" v-if="discountMoney < 0"
                    >共减 ￥{{ Math.abs(discountMoney).toFixed(2) }}</span
                  >
                </div>
                <div class="right">
                  <el-button
                    :loading="isPlaceAnOrder"
                    @click="saveOrUpdateHangingOrder"
                    v-if="actionType == 'openOrder'"
                    >挂单</el-button
                  >
                  <el-button
                    type="primary"
                    :loading="isPlaceAnOrder"
                    @click="placeAnOrder"
                    >收款</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="order-dialog"
      width="500px"
      :visible.sync="dialogOrderVisible"
    >
      <div slot="title">
        <div class="product-info">
          <img class="pic" :src="product.goodsImage" alt />
          <div class="info">
            <p class="title">{{ product.goodsName }}</p>
            <p class="price">￥{{ Number(product.retailPrice).toFixed(1) }}</p>
            <!-- <p class="stock-count">库存：{{ product.totalStockCount }}</p> -->
          </div>
        </div>
      </div>
      <div class="dialog-content">
        <div class="spec-list">
          <div class="item" v-if="product.products && product.products.length">
            <p class="title">规格选择</p>
            <el-radio-group v-model="proSpec" size="small">
              <el-radio
                :label="index"
                border
                v-for="(specItem, index) in product.products"
                :key="index"
                >{{ specItem.valueContent }}</el-radio
              >
            </el-radio-group>
          </div>
          <div
            class="item"
            v-for="(item, index) in product.freeSpecs"
            :key="index"
          >
            <p class="title">{{ item.name }}</p>

            <el-checkbox-group v-model="freeSpec[index]">
              <el-checkbox
                :label="specItem.value"
                border
                v-for="(specItem, index) in item.specValueList"
                :key="index"
                >{{ specItem.value }}</el-checkbox
              >
            </el-checkbox-group>
            <!-- <el-radio-group v-model="freeSpec[index].value" size="small">
                            <el-radio
                                :label="specItem.value"
                                border
                                v-for="(specItem, index) in item.specValueList"
                                :key="index"
                            >{{specItem.value}}</el-radio>
                        </el-radio-group>-->
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogOrderVisible = false">取消</el-button>
        <el-button type="primary" @click="addProduct()" :loading="isSubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="sel-personal-dialog"
      width="500px"
      :visible.sync="dialogSelPersonal"
    >
      <div slot="title" class="dialog-title">{{actionType != "equityCard" ? "手艺人/销售" : "销售"}}</div>
      <div class="dialog-content" v-loading="isLoading">
        <el-radio-group
          v-model="personalType"
          size="small"
          v-if="actionType != 'equityCard'"
        >
          <el-radio-button label="work">手艺人</el-radio-button>
          <el-radio-button label="sale">销售</el-radio-button>
        </el-radio-group>
        <div class="artisans-list">
          <div
            class="item"
            :class="{
              sel:
                (personalType == 'work' && workUserId == item.workUserId) ||
                (personalType == 'sale' && saleUserId == item.workUserId),
            }"
            v-for="item in personalType == 'work'
              ? artisansList
              : completeArtisansList"
            :key="item.workUserId"
            @click="selPersonal(item)"
          >
            {{ item.nickName }}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSelPersonal = false">取消</el-button>
        <el-button type="primary" @click="confirmSelPersonal">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="order-dialog"
      width="500px"
      :visible.sync="dialogOrderNumberVisible"
    >
      <div slot="title" class="dialog-title">输入取餐码</div>
      <div class="dialog-content">
        <el-input
          v-model="orderInfo.orderNumber"
          placeholder="请输入取餐码"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmOrderNumber">确定</el-button>
      </div>
    </el-dialog>
    <div
      :style="{
        left: `${popLeft}px`,
        top: `${popTop}px`,
      }"
      class="position-pop change-price"
      v-if="changePriceVisible"
    >
      <div class="pop-container" @click.stop>
        <div class="change-price-input-box">
          <el-input
            class="value-input"
            v-model="changePriceValue"
            size="mini"
            @input.native="valueInput"
          >
            <template slot="prepend"
              >￥</template
            >
          </el-input>
          <i class="el-icon-sort"></i>
          <el-input
            v-model="changePriceRate"
            size="mini"
            @input.native="rateInput"
          >
            <template slot="append"
              >%</template
            >
          </el-input>
        </div>
        <p class="tips">最低改价金额大于 ¥0.00（0折）</p>
        <div style="text-align: right; margin: 0">
          <el-button size="mini" type="text" @click="changePriceVisible = false"
            >取消</el-button
          >
          <el-button type="primary" size="mini" @click="confirmChangePrice"
            >确定</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowHangingOrder,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>挂单列表</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowHangingOrder = false"
          />
        </div>
        <div class="popup-container">
          <el-radio-group
            v-model="hangingOrderType"
            style="margin-bottom: 30px;"
          >
            <el-radio-button label="hand"
              >手牌({{ hangingOrderHandList.length }})</el-radio-button
            >
            <el-radio-button label="unpay"
              >待付款({{ hangingOrderUnpayList.length }})</el-radio-button
            >
          </el-radio-group>
          <div class="hanging-order-list">
            <div
              class="hanging-order-unpay"
              v-show="hangingOrderType == 'unpay'"
            >
              <div
                class="item"
                v-for="(item, index) in hangingOrderUnpayList"
                :key="item.hangingOrderId"
              >
                <div class="people">
                  <p>{{ item.peopleName || "顾客" }}</p>
                  <p>{{ item.phoneNum }}</p>
                </div>
                <div class="order-info">
                  <p v-if="item.memberCode">
                    <span>会员编号:</span>{{ item.memberCode }}
                  </p>
                  <p><span>消费项目:</span>{{ item.productSubject }}</p>
                  <p>
                    <span>下单时间:</span
                    >{{ item.supplementDateTime || item.createTime }}
                  </p>
                </div>
                <div class="order-footer">
                  <p>￥{{ item.payMoney.toFixed(2) }}</p>
                  <div class="action">
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      @click="cancelOrder(index)"
                      >取消</el-button
                    >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="findHangingOrderInfo(item)"
                      >收款</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="hanging-order-hand" v-show="hangingOrderType == 'hand'">
              <div
                class="item"
                v-for="item in hangingOrderHandList"
                :key="item.handCard"
                @click="findHangingOrderInfo(item)"
              >
                {{ item.handCard }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getEdcShopGoodsCategorys,
  getFindAllGoodsPlus,
  getOrderByTable,
  getShopMemberActivityList,
  changeOrderTable,
  findAllGoodsSample,
  findArtisans,
  findUserCashCoupons,
  getShopMemberList,
  subServiceOrder,
  getTimeCardList,
  memberCardMessage,
  subTimeCardOrder,
  shopMemberRecharge,
  appointmentOrderInfo,
  findHangingOrderList,
  cancelOrder,
  saveOrUpdateHangingOrder,
  findHangingOrderInfo,
  orderInfo,
  findShopWorks,
} from "@/api/index.js";
import merge from "webpack-merge";
import { Message } from "element-ui";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
let isVIP = null;
let remoteTimer = null;
export default {
  mixins: [commonFuc],
  data() {
    return {
      isLoading: false,
      actionType: "openOrder",
      actionTypes: [
        {
          name: "会员充值",
          value: "recharge",
        },
        {
          name: "开单",
          value: "openOrder",
        },
        {
          name: "权益卡",
          value: "equityCard",
        },
      ],
      phoneNumber: "",
      customerUserId: "",
      vipList: [],
      mapVipList: {},
      appointmentOrderId: "",
      hangingOrderId: "",
      loading: false,
      goodsList: [],
      menuList: [],
      menuSel: "hot",
      searchInput: "",
      isShowSearch: false,
      productsList: [],
      changePriceVisible: false,
      popLeft: 0,
      popTop: 0,
      changePriceValue: 0,
      changePriceRate: 0,
      inOrderList: [],
      orderInfo: {
        payMoney: 0,
        mealsNum: 1,
        tableName: "",
        orderNumber: "",
      },
      isEdit: false,
      dialogOrderVisible: false,
      product: {},
      freeSpec: [],
      proSpec: 0,
      sampleGoods: [],
      isLoad: false,
      isSubmit: false,
      dialogOrderNumberVisible: false,
      isHaveOrder: true,
      isPlaceAnOrder: false,
      getIndex: 1,
      isFold: true,
      isSupplement: false, //补单开关
      supplementDate: "",
      timeOption: {
        disabledDate(date) {
          return (
            date.getTime() > Date.now() ||
            date.getTime() < Date.now() - 59 * 60 * 60 * 24 * 1000
          );
        },
      },
      handCards: [],
      mapArtisansList: {},
      artisansList: [
        {
          nickName: "不选择",
          workUserId: "",
        },
      ],
      completeArtisansList: [
        {
          nickName: "不选择",
          workUserId: "",
        },
      ],
      dialogSelPersonal: false,
      selType: "alone",
      orderIndex: 0,
      personalType: "work",
      workUserId: "",
      saleUserId: "",
      selCashCoupon: "",
      userCashCoupons: [],
      remarks: "",
      buyerMark: "",
      discountMoney: 0,

      rechargeValue: 0,
      selRechargeSale: "",
      activityList: [],

      card1List: [],
      card2List: [],
      cardType: 1,
      tabsList: [
        { value: "1", label: "权益卡" },
        { value: "2", label: "次数卡" },
      ],
      cardColorArr: [],
      cardColorObj: {},
      equityCardList: [],

      isShowHangingOrder: false,
      hangingOrderType: "unpay",
      hangingOrderUnpayList: [],
      hangingOrderHandList: [],
      noCashCouponMoney: 0,
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
    totalMoney() {
      let totalMoney = 0;
      let oldGoodList = [];
      let discountMoney = 0;
      let preSpec = "";
      this.goodsList.forEach((goodsVal) => {
        goodsVal.selNum = 0;
        totalMoney = 0;
        discountMoney = 0;
        this.productsList.forEach((val) => {
          console.log(val.customPrice);
          totalMoney += Math.round(val.customPrice * val.buyCount * 100) / 100;
          discountMoney +=
            Math.round(
              (val.customPrice * val.buyCount -
                (isVIP
                  ? val.memberPrice / isVIP.discount +
                    (val.turnoverPrice - val.memberPrice / isVIP.discount)
                  : val.turnoverPrice) *
                  val.buyCount) *
                100
            ) / 100;
          if (val.goodsId == goodsVal.goodsId) {
            if (goodsVal.selNum) {
              goodsVal.selNum += val.buyCount;
            } else {
              goodsVal.selNum = val.buyCount;
            }
          }
        });
        // this.inOrderList.forEach((val) => {
        //   totalMoney += val.turnoverPrice * val.buyCount;
        //   if (val.goodsId == goodsVal.goodsId) {
        //     if (goodsVal.selNum) {
        //       goodsVal.selNum += val.buyCount;
        //     } else {
        //       goodsVal.selNum = val.buyCount;
        //     }
        //   }
        // });
      });
      let selCashCouponItem = this.userCashCoupons.filter((val) => {
        return val.cashCouponId == this.selCashCoupon;
      });
      console.log(selCashCouponItem);
      this.noCashCouponMoney = totalMoney;
      if (selCashCouponItem.length) {
        discountMoney -= selCashCouponItem[0].price;
        totalMoney -= selCashCouponItem[0].price;
      }
      oldGoodList = this.goodsList;
      this.goodsList = [];
      this.goodsList = oldGoodList;
      this.discountMoney = Math.round(discountMoney * 100) / 100;
      console.log(this.discountMoney);
      return totalMoney;
    },
    equityCardTotalMoney() {
      let totalMoney = 0;
      this.equityCardList.forEach((val) => {
        totalMoney += Number(val.vipPrice || val.price);
      });
      return totalMoney;
    },
  },
  watch: {
    searchInput(val) {
      if (!val.length) {
        this.isShowSearch = false;
        this.getFindAllGoodsPlus();
      }
    },
    menuSel() {
      this.getIndex = 1;
      this.getFindAllGoodsPlus();
    },
    proSpec(val) {
      if (this.product.products) {
        this.product.retailPrice = this.product.products[val].retailPrice;
        this.product.totalStockCount = this.product.products[val].stockCount;
      }
    },
    isSupplement() {
      this.supplementDate = "";
    },
  },
  mounted() {
    isVIP = null;
    if (this.$route.query.phoneNumber) {
      this.phoneNumber = this.$route.query.phoneNumber;
      this.remoteMethod(this.$route.query.phoneNumber);
      this.$refs.checkVip.focus();
    }
    if (this.$route.query.orderType) {
      this.actionType = this.$route.query.orderType;
    }
    if (this.$route.query.mallOrderId) {
      this.getOrderInfo(this.$route.query.mallOrderId);
    }
    this.getPageData();
  },
  methods: {
    addEquityCard(item) {
      if (isVIP) {
        item.vipPrice = Number(item.price * isVIP.discount).toFixed(2);
      }
      item.workUserIds = "";
      item.saleUserIds = "";
      this.equityCardList = [item];
      console.log(this.equityCardList);
    },
    clearEquityCardList() {
      this.equityCardList = [];
    },
    getCardListData() {
      this.getTimeCardList();
      this.memberCardMessage();
    },
    change(val) {
      this.cardType = val;
    },
    getTimeCardList() {
      getTimeCardList({
        pageSize: 9999,
        cardType: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.card1List = res.data.list;
        }
        if (res.code == -1) {
          this.card1List = [];
        }
      });
      getTimeCardList({
        pageSize: 9999,
        cardType: 2,
      }).then((res) => {
        if (res.code == 1) {
          this.card2List = res.data.list;
        }
        if (res.code == -1) {
          this.card2List = [];
        }
      });
    },
    memberCardMessage() {
      memberCardMessage({
        // shopMemberCardId: 97
      }).then((res) => {
        res.data.shopMemberCardColors.forEach((color) => {
          color.bg = `${color.startValue},${color.endValue},${color.textColor}`;
          this.cardColorObj[
            `${color.startValue},${color.endValue},${color.textColor}`
          ] = color;
        });
        this.cardColorArr = res.data.shopMemberCardColors;
      });
    },
    getShopMemberActivityList(shopMemberCardId) {
      getShopMemberActivityList({
        activityType: 1,
        shopMemberCardId,
      }).then((res) => {
        if (res.code == 1) {
          this.activityList = JSON.parse(res.data[0].itemContent);
        }
      });
    },
    resetPopVisible() {
      this.changePriceVisible = false;
    },
    showChangePrice(index) {
      let rect = document
        .querySelector(`.cp-btn${index}`)
        .getBoundingClientRect();
      console.log(rect);
      let offsetX = rect.right;
      let offsetY = rect.top + rect.height;
      this.popLeft = offsetX - 300;
      this.popTop = offsetY + 10;
      this.changePriceVisible = true;
      this.changePriceIndex = index;
      let item = this.productsList[index];
      this.changePriceValue = item.customPrice.toFixed(2);
      this.changePriceRate =
        ((this.changePriceValue /
          (isVIP ? item.memberPrice : item.turnoverPrice)) *
          100 *
          10) /
          10 || 0;
    },
    valueInput(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      e.target.value = e.target.value.replace(/^\./g, "0.");
      e.target.value = e.target.value.replace(
        /^\d*\.\d*\./g,
        e.target.value.substring(0, e.target.value.length - 1)
      );
      if (!e.target.value) {
        e.target.value = 0;
      }
      if (e.target.value < 0) {
        e.target.value = 0;
      }
      let item = this.productsList[this.changePriceIndex];
      this.changePriceRate =
        ((e.target.value /
          (isVIP ? item.memberPrice : item.turnoverPrice).toFixed(2)) *
          1000) /
        10;
    },
    rateInput(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      e.target.value = e.target.value.replace(/^\./g, "0.");
      e.target.value = e.target.value.replace(
        /^\d*\.\d*\./g,
        e.target.value.substring(0, e.target.value.length - 1)
      );
      if (!e.target.value || e.target.value == 0) {
        e.target.value = 0;
      }
      if (e.target.value <= 0) {
        e.target.value = 0;
      }
      let item = this.productsList[this.changePriceIndex];
      this.changePriceValue = (
        (e.target.value / 100) *
        (isVIP ? item.memberPrice : item.turnoverPrice)
      ).toFixed(2);
    },
    rechargeValueInput(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      e.target.value = e.target.value.replace(/\.{2,}/g, ".");
      e.target.value = e.target.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
      e.target.value = e.target.value.replace(/^\./g, "0.");
      e.target.value = e.target.value.replace(
        /^\d*\.\d*\./g,
        e.target.value.substring(0, e.target.value.length - 1)
      );
      if (!e.target.value || e.target.value == 0) {
        e.target.value = 0;
      }
      if (e.target.value <= 0) {
        e.target.value = 0;
      }
    },
    confirmChangePrice() {
      if (this.changePriceValue <= 0) {
        return this.$notify.error("改价金额不能小等于0");
      }
      let item = this.productsList[this.changePriceIndex];
      this.productsList[this.changePriceIndex].customPrice =
        Math.round(this.changePriceValue * 1e2) / 1e2;
      this.selCashCoupon = "";
      this.changePriceVisible = false;
    },
    confirmSelPersonal() {
      if (this.selType == "alone") {
        if (this.actionType == "openOrder") {
          this.productsList[this.orderIndex].workUserIds = this.workUserId;
          this.productsList[this.orderIndex].saleUserIds = this.saleUserId;
        }
        if (this.actionType == "equityCard") {
          this.equityCardList[this.orderIndex].workUserIds = this.workUserId;
          this.equityCardList[this.orderIndex].saleUserIds = this.saleUserId;
          console.log(
            "confirmSelPersonal",
            this.equityCardList,
            this.mapArtisansList
          );
        }
      }
      if (this.selType == "batch") {
        if (this.actionType == "openOrder") {
          this.productsList.forEach((val) => {
            val.workUserIds = this.workUserId;
            val.saleUserIds = this.saleUserId;
          });
        }
        if (this.actionType == "equityCard") {
          this.equityCardList.forEach((val) => {
            val.workUserIds = this.workUserId;
            val.saleUserIds = this.saleUserId;
          });
        }
      }
      this.dialogSelPersonal = false;
    },
    findArtisans() {
      findArtisans({
        row: 99999,
      }).then((res) => {
        this.artisansList = [
          {
            nickName: "不选择",
            workUserId: "",
          },
        ];
        if (res.code == 1) {
          this.artisansList.push(...res.data);
          res.data.forEach((val) => {
            this.mapArtisansList[val.workUserId] = val;
          });
          // this.completeArtisansList = this.artisansList;
        }
        if (res.code == -1) {
          this.artisansList = [
            {
              nickName: "不选择",
              workUserId: "",
            },
          ];
        }
      });
      findShopWorks({
        row: 99999,
        isAll: 1,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.nickName = val.fullName;
            val.workUserId = val.shopWorkerUserId;
            this.mapArtisansList[val.workUserId] = val;
          });
          this.completeArtisansList.push(...res.data);
        }
        if (res.code == -1) {
          this.completeArtisansList = [
            {
              nickName: "不选择",
              workUserId: "",
            },
          ];
        }
      });
    },
    findUserCashCoupons() {
      this.selCashCoupon = "";
      this.userCashCoupons = [];
      if (!this.customerUserId) {
        return;
      }
      findUserCashCoupons({
        pageNo: 1,
        row: 9999,
        customerUserId: this.customerUserId,
        usedStatus: -105,
      }).then((res) => {
        if (res.code == 1) {
          this.userCashCoupons = res.data.filter((val) => {
            return val.openDoubleDiscounts == 1;
          });
        }
      });
    },
    clearProductsList() {
      this.selCashCoupon = "";
      this.productsList = [];
    },
    delProducts(index) {
      this.selCashCoupon = "";
      this.productsList.splice(index, 1);
    },
    showSelPersonal(item, index) {
      this.selType = "alone";
      this.orderIndex = index;
      if (this.actionType != "equityCard") {
        this.personalType = !item.workUserIds ? "work" : "sale";
      } else {
        this.personalType = "sale";
      }
      this.workUserId = item.workUserIds;
      this.saleUserId = item.saleUserIds;
      this.dialogSelPersonal = true;
      this.isLoading = true;
      findArtisans({
        goodsId: item.goodsId,
        productId: item.productId || "",
        row: 99999,
      }).then((res) => {
        this.artisansList = [
          {
            nickName: "不选择",
            workUserId: "",
          },
        ];
        if (res.code == 1) {
          this.artisansList.push(...res.data);
        }
        if (res.code == -1) {
          this.artisansList = [
            {
              nickName: "不选择",
              workUserId: "",
            },
          ];
        }
        this.isLoading = false;
      });
    },
    batchSelPersonal() {
      this.selType = "batch";
      if (this.actionType != "equityCard") {
        this.personalType = "work";
      } else {
        this.personalType = "sale";
      }
      this.workUserId = "";
      this.saleUserId = "";
      this.dialogSelPersonal = true;
      // this.artisansList = this.completeArtisansList;
      // this.findArtisans()
    },
    selPersonal(item) {
      console.log(item);
      if (this.personalType == "work") {
        this.workUserId = item.workUserId;
      }
      if (this.personalType == "sale") {
        this.saleUserId = item.workUserId;
      }
    },
    resetSearch() {
      this.isShowSearch = false;
      this.searchInput = "";
      this.getFindAllGoodsPlus();
    },
    getFindAllGoodsPlus() {
      this.isLoad = true;
      let params = {
        goodsNatureType: 2,
        saleStatus: 1,
        row: 99999,
        pageNo: 1,
        isHideRequired: 1,
        goodsName: this.searchInput,
      };
      if (!this.searchInput.length) {
        if (this.menuSel == "hot") {
          params.hotSale = 1;
        } else {
          params.goodsCategoryId = this.menuSel;
        }
        this.isShowSearch = false;
      } else {
        this.isShowSearch = true;
      }
      getFindAllGoodsPlus(params).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (!val.memberPrice) {
              val.memberPrice = val.retailPrice;
            }
            val.products.forEach((subval) => {
              if (!subval.memberPrice) {
                subval.memberPrice = subval.retailPrice;
              }
            });
          });
          this.goodsList = res.data;
        }
        if (res.code == -1) {
          this.goodsList = [];
        }
        this.isLoad = false;
      });
    },
    changeMealsNum(command) {
      this.orderInfo.mealsNum = command;
      if (this.shop.needChoosePeopleNum) {
        this.findAllGoodsSample();
      }
    },
    changeTable(command) {
      changeOrderTable({
        mallOrderId: this.orderInfo.mallOrderId,
        shoppingTableId: command.shoppingTableId,
      }).then((res) => {
        if (res.code == 1) {
          this.orderInfo = Object.assign({}, this.orderInfo, {
            tableName: command.tableName,
          });
          this.shoppingTableId = command.shoppingTableId;
          this.$router.push({
            query: merge(this.$route.query, {
              shoppingTableId: command.shoppingTableId,
              tableName: command.tableName,
            }),
          });
          this.$notify({
            title: "提示",
            message: "换桌成功",
            type: "success",
            duration: 2000,
          });
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    toggleEdit() {
      this.isEdit = !this.isEdit;
    },
    async getPageData() {
      this.findArtisans();
      if (this.$route.query.appointmentOrderId) {
        this.appointmentOrderId = this.$route.query.appointmentOrderId;
        await appointmentOrderInfo({
          appointmentOrderId: this.appointmentOrderId,
        }).then((res) => {
          if (res.code == 1) {
            getFindAllGoodsPlus({
              goodsNatureType: 2,
              goodsId: res.data.goodsId,
            }).then((resp) => {
              if (resp.code == 1) {
                resp.data.forEach((val) => {
                  if (val.goodsId == res.data.goodsId) {
                    this.productsList = [
                      {
                        buyCount: 1,
                        goodsCategoryId: val.goodsCategoryId,
                        goodsId: val.goodsId,
                        goodsName: val.goodsName,
                        productId: res.data.productId,
                        productSaleStatus: 2,
                        specDesc: res.data.specDesc,
                        turnoverPrice: 0,
                        memberPrice: 0,
                        oldMemberPrice: 0,
                        customPrice: 0,
                        workUserIds: res.data.workUserId,
                        saleUserIds: res.data.saleUserId,
                      },
                    ];
                    if (res.data.productId) {
                      val.products.forEach((subval) => {
                        if (subval.productId == res.data.productId) {
                          this.productsList[0].turnoverPrice =
                            subval.retailPrice;
                          this.productsList[0].memberPrice =
                            subval.memberPrice || subval.retailPrice;
                          this.productsList[0].oldMemberPrice =
                            subval.memberPrice || subval.retailPrice;
                          this.productsList[0].customPrice = subval.retailPrice;
                        }
                      });
                    } else {
                      this.productsList[0].turnoverPrice = val.retailPrice;
                      this.productsList[0].memberPrice =
                        val.memberPrice || val.retailPrice;
                      this.productsList[0].oldMemberPrice =
                        val.memberPrice || val.retailPrice;
                      this.productsList[0].customPrice = val.retailPrice;
                    }
                  }
                });
                let orderData = res.data;
                if (res.data.shopMemberId) {
                  this.$refs.checkVip.focus();
                  getShopMemberList({
                    pageNo: 1,
                    row: 9999,
                    shopMemberId: res.data.shopMemberId,
                  }).then((res) => {
                    if (res.code == 1) {
                      res.data.forEach((val) => {
                        this.mapVipList[val.customerUserId] = val;
                      });
                      this.phoneNumber = res.data.phoneNum;
                      this.vipList = res.data;
                      if (res.data.length == 1) {
                        this.selVip(res.data[0].customerUserId);
                      }
                      setTimeout(() => {
                        this.selCashCoupon = orderData.cashCouponId;
                      }, 500);
                    }
                  });
                }
              }
            });
          }
        });
      }
      getEdcShopGoodsCategorys({
        categoryNatureType: 2,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          res.data.unshift({
            categoryName: "热销",
            goodsCategoryId: "hot",
          });
          this.menuList = res.data;
          this.getFindAllGoodsPlus();
        }
      });
      this.findHangingOrderList();
    },
    findHangingOrderList() {
      findHangingOrderList({
        pageNo: 1,
        row: 9999,
      }).then((res) => {
        this.hangingOrderUnpayList = [];
        if (res.code == 1) {
          this.hangingOrderUnpayList = res.data;
        }
      });
      findHangingOrderList({
        pageNo: 1,
        row: 9999,
        isOnlyShowHandCards: 1,
      }).then((res) => {
        this.hangingOrderHandList = [];
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (val.handCards.indexOf(",") != -1) {
              val.handCards.split(",").forEach((subval) => {
                let newVal = JSON.parse(JSON.stringify(val));
                newVal.handCard = subval;
                this.hangingOrderHandList.push(newVal);
              });
            } else {
              val.handCard = val.handCards;
              this.hangingOrderHandList.push(val);
            }
          });
        }
      });
    },
    findAllGoodsSample() {
      findAllGoodsSample({
        isRequired: this.shop.needChoosePeopleNum ? 5 : 4,
      }).then((sampleRes) => {
        if (sampleRes.code == 1) {
          this.sampleGoods = sampleRes.data;
          this.sampleGoods.forEach((val) => {
            this.productsList.forEach((subval, index) => {
              if (val.goodsId == subval.goodsId) {
                this.productsList.splice(index, 1);
              }
            });
            // this.inOrderList.forEach((subval, index) => {
            //   if (val.goodsId == subval.goodsId) {
            //     this.inOrderList.splice(index, 1);
            //   }
            // });
            this.productsList.forEach((subval, index) => {
              if (val.goodsId == subval.goodsId) {
                this.productsList.splice(index, 1);
              }
            });
          });
          this.sampleGoods.forEach((val, index) => {
            for (let i = 0; i < this.orderInfo.mealsNum; i++) {
              this.openDialog(index, "sample");
            }
          });
        }
      });
    },
    productNumChange(val, index) {
      if (val == 0) {
        this.productsList.splice(index, 1);
      }
      this.productsList[index].customPrice = isVIP
        ? this.productsList[index].memberPrice
        : this.productsList[index].turnoverPrice;

      this.selCashCoupon = "";
    },
    openDialog(index, type = "add") {
      if (type == "add") {
        this.product = this.goodsList[index];
      } else {
        this.product = this.sampleGoods[index];
      }
      this.freeSpec = [];
      this.proSpec = 0;
      // if (this.product.totalStockCount <= 0) {
      //   this.$notify({
      //     title: "提示",
      //     message: "该商品库存不足",
      //     type: "warning",
      //   });
      //   return;
      // }
      if (this.product.freeSpecs && this.product.freeSpecs.length) {
        this.product.freeSpecs.forEach((val) => {
          // this.freeSpec.push({
          //     value: val.specValueList[0].value
          // });
          this.freeSpec.push([]);
        });
      }
      if (
        !(this.product.freeSpecs && this.product.freeSpecs.length) &&
        !(this.product.products && this.product.products.length)
      ) {
        this.addProduct(type);
      } else {
        if (this.product.products && this.product.products.length) {
          this.product.retailPrice = this.product.products[
            this.proSpec
          ].retailPrice;
          this.product.totalStockCount = this.product.products[
            this.proSpec
          ].stockCount;
        }
        this.dialogOrderVisible = true;
      }
    },
    addProduct(type = "add") {
      this.isSubmit = true;
      let products = this.product.products || [];
      let specDesc = products.length ? products[this.proSpec].valueContent : "";
      let isMerge = false;
      let productIndex = 0;
      let freeSpec = [];
      this.freeSpec.forEach((val) => {
        freeSpec.push(...val);
      });
      specDesc += freeSpec.length ? `,${freeSpec.join(",")}` : "";
      // if (this.product.totalStockCount <= 0) {
      //   this.$notify({
      //     title: "提示",
      //     message: "该商品库存不足",
      //     type: "warning",
      //   });
      //   this.isSubmit = false;
      //   return;
      // }
      if (this.productsList.length) {
        this.productsList.forEach((val, index) => {
          if (
            val.goodsId == this.product.goodsId &&
            val.goodsCategoryId == this.product.goodsCategoryId &&
            (val.specDesc == specDesc || val.specDesc == undefined)
          ) {
            isMerge = true;
            productIndex = index;
          }
        });
        if (isMerge) {
          this.productsList[productIndex].buyCount++;
        } else {
          this.productsList.push({
            buyCount: 1,
            goodsCategoryId: this.product.goodsCategoryId,
            goodsId: this.product.goodsId,
            goodsName: this.product.goodsName,
            productId: products.length ? products[this.proSpec].productId : "",
            productSaleStatus: 2,
            specDesc: specDesc,
            turnoverPrice: products.length
              ? products[this.proSpec].retailPrice
              : this.product.retailPrice,
            memberPrice:
              (products.length
                ? products[this.proSpec].memberPrice
                : this.product.memberPrice) * (isVIP ? isVIP.discount : 1),
            oldMemberPrice:
              (products.length
                ? products[this.proSpec].memberPrice
                : this.product.memberPrice) * (isVIP ? isVIP.discount : 1),
            customPrice:
              (isVIP
                ? products.length
                  ? products[this.proSpec].memberPrice
                  : this.product.memberPrice
                : products.length
                ? products[this.proSpec].retailPrice
                : this.product.retailPrice) * (isVIP ? isVIP.discount : 1),
            workUserIds: "",
            saleUserIds: "",
          });
        }
      } else {
        this.productsList.push({
          buyCount: 1,
          goodsCategoryId: this.product.goodsCategoryId,
          goodsId: this.product.goodsId,
          goodsName: this.product.goodsName,
          productId: products.length ? products[this.proSpec].productId : "",
          productSaleStatus: 2,
          specDesc: specDesc,
          turnoverPrice: products.length
            ? products[this.proSpec].retailPrice
            : this.product.retailPrice,
          memberPrice:
            (products.length
              ? products[this.proSpec].memberPrice
              : this.product.memberPrice) * (isVIP ? isVIP.discount : 1),
          oldMemberPrice:
            (products.length
              ? products[this.proSpec].memberPrice
              : this.product.memberPrice) * (isVIP ? isVIP.discount : 1),
          customPrice:
            (isVIP
              ? products.length
                ? products[this.proSpec].memberPrice
                : this.product.memberPrice
              : products.length
              ? products[this.proSpec].retailPrice
              : this.product.retailPrice) * (isVIP ? isVIP.discount : 1),
          workUserIds: "",
          saleUserIds: "",
        });
      }
      this.productsList = this.productsList;
      this.dialogOrderVisible = false;
      setTimeout(() => {
        this.isSubmit = false;
      }, 500);
    },
    placeAnOrder() {
      if (this.actionType == "openOrder") {
        if (!this.productsList.length) {
          this.$notify({
            title: "提示",
            message: "请先选择服务才能下单",
            type: "warning",
          });
          return;
        }
        if (this.isSupplement && !this.supplementDate) {
          return this.$notify({
            title: "提示",
            message: "请输入补录日期",
            type: "warning",
          });
        }
        let productsList = JSON.parse(JSON.stringify(this.productsList));
        this.isPlaceAnOrder = true;
        let payMoney = 0;
        let products = [];
        productsList.forEach((val, index) => {
          payMoney += val.buyCount * val.turnoverPrice;
          products.push({
            goodsName: val.goodsName,
            goodsId: val.goodsId,
            productId: val.productId,
            buyCount: val.buyCount,
            specDesc: val.specDesc,
            workUserIds: val.workUserIds,
            saleUserIds: val.saleUserIds,
          });
          if (
            val.customPrice != (isVIP ? val.memberPrice : val.turnoverPrice)
          ) {
            products[index].customPrice = val.customPrice;
          }
        });
        let handCards = "";
        this.handCards.forEach((val) => {
          if (handCards.length) {
            handCards += `,${val.card}`;
          } else {
            handCards = `${val.card}`;
          }
        });

        subServiceOrder({
          appointmentOrderId: this.appointmentOrderId,
          hangingOrderId: this.hangingOrderId,
          mallOrderId: this.$route.query.mallOrderId,
          orderCategory: 20,
          isSupplement: this.isSupplement ? 1 : 0,
          supplementDateTime: this.supplementDate
            ? new Date(this.supplementDate).pattern("yyyy-MM-dd HH:mm:ss")
            : "",
          phoneNum: isVIP ? isVIP.phoneNum : "顾客" + +new Date(),
          peopleName: isVIP ? isVIP.fullName : "顾客" + +new Date(),
          shopMemberId: isVIP ? isVIP.shopMemberId : "",
          cashCouponId: this.selCashCoupon,
          payMoney: this.totalMoney.toFixed(2),
          shoperRemark: this.remarks,
          buyerMark: this.buyerMark,
          handCards: handCards,
          products: JSON.stringify(products),
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "下单成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push(
                `/home/order/pay?orderType=${this.actionType}&mallOrderId=${
                  res.data.mallOrderId
                }`
              );
            }, 5e2);
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
          this.isPlaceAnOrder = false;
        });
      }
      if (this.actionType == "equityCard") {
        if (!this.equityCardList.length) {
          this.$notify({
            title: "提示",
            message: "请先选择权益卡",
            type: "warning",
          });
          return;
        }
        if (this.isSupplement && !this.supplementDate) {
          return this.$notify({
            title: "提示",
            message: "请输入补录日期",
            type: "warning",
          });
        }
        this.isPlaceAnOrder = true;
        subTimeCardOrder({
          customerUserId: this.customerUserId,
          cashCouponId: this.selCashCoupon,
          timeCardId: this.equityCardList[0].id,
          saleUserId: this.equityCardList[0].saleUserIds,
          payMoney: Number(this.equityCardTotalMoney / isVIP.discount).toFixed(
            2
          ),
          shoperRemark: this.remarks,
          isSupplement: this.isSupplement ? 1 : 0,
          supplementDateTime: this.supplementDate
            ? new Date(this.supplementDate).pattern("yyyy-MM-dd HH:mm:ss")
            : "",
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "下单成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push(
                `/home/order/pay?orderType=${this.actionType}&mallOrderId=${
                  res.data.mallOrderId
                }`
              );
            }, 5e2);
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
          this.isPlaceAnOrder = false;
        });
      }
      if (this.actionType == "recharge") {
        if (!this.rechargeValue) {
          return this.$notify({
            title: "提示",
            message: "请输入充值金额",
            type: "error",
            duration: 1000,
          });
        }
        shopMemberRecharge({
          shopMemberId: isVIP.shopMemberId,
          payMoney: this.rechargeValue,
          receiptType: 2,
          saleUserId: this.selRechargeSale,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "下单成功",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push(
                `/home/order/pay?orderType=${this.actionType}&mallOrderId=${
                  res.data.mallOrderId
                }`
              );
            }, 5e2);
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
          this.isPlaceAnOrder = false;
        });
      }
    },
    confirmOrderNumber() {
      if (this.orderInfo.orderNumber) {
        this.dialogOrderNumberVisible = false;
      } else {
        this.$notify({
          title: "提示",
          message: "请输入取餐码",
          type: "error",
          duration: 2000,
        });
      }
    },
    selVip(item, type = "normal") {
      if (type == "normal") {
        this.productsList.forEach((val) => {
          val.memberPrice = Number(val.oldMemberPrice.toFixed(2));
          val.customPrice = val.memberPrice;
          val.oldCustomPrice = "";
        });
        this.equityCardList.forEach((val) => {
          val.vipPrice = Number(val.price.toFixed(2));
        });
      }
      this.customerUserId = item;
      this.vipList = [];
      this.findUserCashCoupons();
      isVIP = this.mapVipList[this.customerUserId];
      if (!isVIP) return;
      if (
        this.$route.query.mallOrderId &&
        this.$route.query.orderType == "equityCard"
      ) {
        this.equityCardList.forEach((val) => {
          val.price = Number((val.price / isVIP.discount).toFixed(2));
        });
      }
      this.getShopMemberActivityList(isVIP.shopMemberCardId);
      this.getCardListData();
      console.log(isVIP);
      this.productsList.forEach((val) => {
        console.log(val);
        // if (isVIP) {
        val.memberPrice = Number(
          (val.oldMemberPrice * (isVIP ? isVIP.discount : 1)).toFixed(2)
        );
        // console.log(
        //   (val.memberPrice * (isVIP ? isVIP.discount : 1)).toFixed(2),
        //   isVIP ? isVIP.discount : 1,
        //   val
        // );
        // }
        if (
          (val.customPrice == val.oldMemberPrice ||
            val.customPrice == val.turnoverPrice) &&
          !val.oldCustomPrice
        ) {
          val.customPrice = val.memberPrice;
        }
        console.log(isVIP.discount, val);
      });
      this.equityCardList.forEach((val) => {
        val.vipPrice = Number(
          (val.price * (isVIP ? isVIP.discount : 1)).toFixed(2)
        );
      });
    },
    clearVip() {
      this.productsList.forEach((val) => {
        if (val.customPrice == val.memberPrice) {
          val.customPrice = val.turnoverPrice;
        }
        console.log(isVIP.discount, val);
      });
      this.equityCardList.forEach((val) => {
        val.vipPrice = Number(val.price.toFixed(2));
      });
      isVIP = null;
      this.customerUserId = "";
      this.actionType = "openOrder";
      console.log("clearVip");
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        clearTimeout(remoteTimer);
        remoteTimer = setTimeout(() => {
          getShopMemberList({
            pageNo: 1,
            row: 9999,
            phoneNum: String(query),
          }).then((res) => {
            if (res.code == 1) {
              res.data.forEach((val) => {
                this.mapVipList[val.customerUserId] = val;
              });
              this.vipList = res.data;
              if (this.vipList.length == 1) {
                this.selVip(this.vipList[0].customerUserId);
              }
            }
            if (res.code == -1) {
              this.vipList = [];
              this.phoneNumber = "";
              this.$message.error("该用户不是会员");
            }
            this.loading = false;
          });
        }, 1e3);
      } else {
        this.vipList = [];
      }
    },
    handleClose(index) {
      this.handCards.splice(index, 1);
    },
    tagClick(index) {
      this.handCards[index].attrValueInputVisible = true;
      this.$refs[`saveTagInput${index}`][0].focus();
    },
    addHandCard() {
      this.handCards.push({
        card: "",
        attrValueInputVisible: true,
      });
      this.$nextTick((_) => {
        this.$refs[`saveTagInput${this.handCards.length - 1}`][0].focus();
      });
    },
    handleAttrValueInputConfirm(index) {
      console.log(
        this.handCards.findIndex((val) => {
          return val.card == this.handCards[index].card;
        })
      );
      let findIndex = this.handCards.findIndex((val) => {
        return val.card == this.handCards[index].card;
      });
      if (findIndex != -1 && findIndex != index) {
        this.handleClose(index);
        return this.$notify.error("手牌不能重复");
      }
      if (this.handCards[index].card.length) {
        this.handCards[index].attrValueInputVisible = false;
      } else {
        this.handleClose(index);
      }
    },
    cancelOrder(index) {
      this.$confirm("确定取消当前订单吗？", "取消预约", {
        confirmButtonText: "确定取消",
        cancelButtonText: "暂不取消",
        type: "warning",
      }).then(({}) => {
        cancelOrder({
          hangingOrderId: this.hangingOrderUnpayList[index].hangingOrderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消成功",
              type: "success",
              duration: 2000,
            });
            // this.hangingOrderUnpayList.splice(index, 1);
            this.findHangingOrderList();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        });
      });
    },
    getOrderInfo(mallOrderId) {
      orderInfo({
        mallOrderId,
        customParam: "headLogo,sex,cashierUserFullName",
      }).then((res) => {
        if (res.code == 1) {
          this.phoneNumber = "";
          this.customerUserId = "";
          let orderData = res.data;
          this.hangingOrderId = res.data.hangingOrderId;
          this.appointmentOrderId = res.data.appointmentOrderId;
          this.isSupplement = res.data.isSupplement == 1 ? true : false;
          setTimeout(() => {
            this.supplementDate = res.data.supplementDateTime;
          }, 500);
          this.selCashCoupon = res.data.cashCouponId;
          this.remarks = res.data.orderMark;
          this.buyerMark = res.data.buyerMark;
          this.handCards = [];
          if (res.data.handCards) {
            res.data.handCards.split(",").forEach((val) => {
              this.handCards.push({
                card: val,
                attrValueInputVisible: false,
              });
            });
          }
          this.productsList = [];
          if (this.$route.query.orderType == "recharge") {
            this.rechargeValue = res.data.products[0].totalTurnoverPrice;
            this.selRechargeSale = res.data.saleUserId;
          } else {
            res.data.products.forEach((val) => {
              if (this.$route.query.orderType == "equityCard") {
                this.equityCardList.push({
                  buyCount: val.buyCount,
                  cardName: val.goodsName,
                  productSaleStatus: 2,
                  turnoverPrice: val.turnoverPrice,
                  memberPrice: val.turnoverPrice,
                  oldMemberPrice: val.turnoverPrice,
                  customPrice: val.turnoverPrice,
                  oldCustomPrice: val.turnoverPrice,
                  price: val.turnoverPrice,
                  vipPrice: val.turnoverPrice,
                  workUserIds: val.workUserIds,
                  saleUserIds: res.data.saleUserId,
                  id: val.timeCardId,
                });
              } else {
                this.productsList.push({
                  buyCount: val.buyCount,
                  goodsCategoryId: val.goodsCategoryId,
                  goodsId: val.goodsId,
                  goodsName: val.goodsName,
                  productId: val.productId,
                  productSaleStatus: 2,
                  specDesc: val.specDesc,
                  turnoverPrice: val.retailPrice,
                  memberPrice: val.memberPrice || val.retailPrice,
                  oldMemberPrice: val.memberPrice || val.retailPrice,
                  customPrice:
                    val.customPrice ||
                    (res.data.shopMemberId
                      ? val.memberPrice || val.retailPrice
                      : val.retailPrice),
                  oldCustomPrice: val.customPrice,
                  workUserIds: val.workUserIds,
                  saleUserIds: val.saleUserIds,
                });
              }
            });
          }
          if (res.data.shopMemberId) {
            this.$refs.checkVip.focus();
            getShopMemberList({
              pageNo: 1,
              row: 9999,
              shopMemberId: res.data.shopMemberId,
            }).then((res) => {
              if (res.code == 1) {
                res.data.forEach((val) => {
                  this.mapVipList[val.customerUserId] = val;
                });
                this.phoneNumber = res.data.phoneNum;
                this.vipList = res.data;
                if (res.data.length == 1) {
                  this.selVip(res.data[0].customerUserId, "hanging");
                }
                setTimeout(() => {
                  this.selCashCoupon = orderData.cashCouponId;
                }, 500);
              }
              this.isShowHangingOrder = false;
            });
          } else {
            this.isShowHangingOrder = false;
          }
          console.log("gethandling order", this.productsList);
          this.actionType = "openOrder";
          if (this.$route.query.orderType) {
            this.actionType = this.$route.query.orderType;
          }
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    findHangingOrderInfo(item) {
      findHangingOrderInfo({
        hangingOrderId: item.hangingOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.phoneNumber = "";
          this.customerUserId = "";
          let orderData = res.data;
          this.hangingOrderId = res.data.hangingOrderId;
          this.appointmentOrderId = res.data.appointmentOrderId;
          this.isSupplement = res.data.isSupplement == 1 ? true : false;
          setTimeout(() => {
            this.supplementDate = res.data.supplementDateTime;
          }, 500);
          this.selCashCoupon = res.data.cashCouponId;
          this.remarks = res.data.shoperRemark;
          this.buyerMark = res.data.buyerMark;
          this.handCards = [];
          if (res.data.handCards) {
            res.data.handCards.split(",").forEach((val) => {
              this.handCards.push({
                card: val,
                attrValueInputVisible: false,
              });
            });
          }
          this.productsList = [];
          JSON.parse(res.data.products).forEach((val) => {
            this.productsList.push({
              buyCount: val.buyCount,
              goodsCategoryId: val.goodsCategoryId,
              goodsId: val.goodsId,
              goodsName: val.goodsName,
              productId: val.productId,
              productSaleStatus: 2,
              specDesc: val.specDesc,
              turnoverPrice: val.retailPrice,
              memberPrice: val.memberPrice || val.retailPrice,
              oldMemberPrice: val.memberPrice || val.retailPrice,
              customPrice:
                val.customPrice ||
                (res.data.shopMemberId
                  ? val.memberPrice || val.retailPrice
                  : val.retailPrice),
              oldCustomPrice: val.customPrice,
              workUserIds: val.workUserIds,
              saleUserIds: val.saleUserIds,
            });
          });
          if (res.data.shopMemberId) {
            this.$refs.checkVip.focus();
            getShopMemberList({
              pageNo: 1,
              row: 9999,
              shopMemberId: res.data.shopMemberId,
            }).then((res) => {
              if (res.code == 1) {
                res.data.forEach((val) => {
                  this.mapVipList[val.customerUserId] = val;
                });
                this.phoneNumber = res.data.phoneNum;
                this.vipList = res.data;
                if (res.data.length == 1) {
                  this.selVip(res.data[0].customerUserId, "hanging");
                }
                setTimeout(() => {
                  this.selCashCoupon = orderData.cashCouponId;
                }, 500);
              }
              this.isShowHangingOrder = false;
            });
          } else {
            this.isShowHangingOrder = false;
          }
          console.log("gethandling order", this.productsList);
          this.actionType = "openOrder";
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    saveOrUpdateHangingOrder() {
      if (!this.productsList.length) {
        this.$notify({
          title: "提示",
          message: "请先选择服务才能挂单",
          type: "warning",
        });
        return;
      }
      if (this.isSupplement && !this.supplementDate) {
        return this.$notify({
          title: "提示",
          message: "请输入补录日期",
          type: "warning",
        });
      }
      let productsList = JSON.parse(JSON.stringify(this.productsList));
      this.isPlaceAnOrder = true;
      let payMoney = 0;
      let products = [];
      productsList.forEach((val, index) => {
        payMoney += val.buyCount * val.turnoverPrice;
        products.push({
          goodsName: val.goodsName,
          goodsId: val.goodsId,
          productId: val.productId,
          buyCount: val.buyCount,
          specDesc: val.specDesc,
          workUserIds: val.workUserIds,
          saleUserIds: val.saleUserIds,
        });
        if (val.customPrice != (isVIP ? val.memberPrice : val.turnoverPrice)) {
          products[index].customPrice = val.customPrice;
        }
      });
      let handCards = "";
      this.handCards.forEach((val) => {
        if (handCards.length) {
          handCards += `,${val.card}`;
        } else {
          handCards = `${val.card}`;
        }
      });
      saveOrUpdateHangingOrder({
        hangingOrderId: this.hangingOrderId,
        appointmentOrderId: this.appointmentOrderId,
        orderCategory: 20,
        orderCategory: 20,
        isSupplement: this.isSupplement ? 1 : 0,
        supplementDateTime: this.supplementDate
          ? new Date(this.supplementDate).pattern("yyyy-MM-dd HH:mm:ss")
          : "",
        phoneNum: isVIP ? isVIP.phoneNum : "顾客" + +new Date(),
        peopleName: isVIP ? isVIP.fullName : "顾客" + +new Date(),
        shopMemberId: isVIP ? isVIP.shopMemberId : "",
        cashCouponId: this.selCashCoupon,
        payMoney: this.totalMoney.toFixed(2),
        shoperRemark: this.remarks,
        buyerMark: this.buyerMark,
        handCards: handCards,
        products: JSON.stringify(products),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "挂单成功",
            type: "success",
          });
          this.findHangingOrderList();
          this.resetForm();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
        this.isPlaceAnOrder = false;
      });
    },
    resetForm() {
      this.hangingOrderId = "";
      this.customerUserId = "";
      this.phoneNumber = "";
      this.appointmentOrderId = "";
      this.isSupplement = false;
      this.supplementDate = "";
      this.selCashCoupon = "";
      this.remarks = "";
      this.buyerMark = "";
      this.handCards = [];
      this.productsList = [];
      this.isFold = true;
      isVIP = null;
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  height: 100%;
  overflow: hidden;
  .bd {
    height: 100%;
    .tab-header {
      .header-left {
        .vip-info {
          margin-left: 10px;
          display: flex;
          align-items: center;
          .head-logo {
            width: 20px;
            height: 20px;
            background: #ccc;
            border-radius: 100%;
            margin-right: 10px;
          }
          .el-icon-error {
            font-size: 20px;
            color: #606266;
            transition: color 0.15s linear;
            margin-left: 10px;
            margin-top: 3px;
            cursor: pointer;
            &:hover {
              color: #409eff;
            }
          }
        }
      }
      .header-right {
        .hanging-btn {
          margin-right: 20px;
        }
      }
    }
  }
  .tab-content {
    height: calc(100% - 63px);
    width: 100%;
    .main {
      width: 100%;
      display: flex;
      padding-top: 0;
      height: 100%;
      .project-content {
        display: flex;
        min-width: 50%;
        height: 100%;
        flex-direction: column;
        .project-header {
          width: 100%;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
          .action-type {
            width: 100%;
            display: flex;
            flex-direction: row;
            box-sizing: border-box;
            .item {
              flex: 1;
              height: 40px;
              line-height: 40px;
              text-align: center;
              font-size: 16px;
              border: 1px solid #dcdee0;
              cursor: pointer;
              font-weight: 500;
              &.active {
                color: #409eff;
                background: #ecf5ff;
                border-color: #b3d8ff;
              }
              &:first-child {
                border-top-left-radius: 2px;
                border-bottom-left-radius: 2px;
                border-right: 0;
              }
              &:last-child {
                border-left: 0;
                border-top-right-radius: 2px;
                border-bottom-right-radius: 2px;
              }
            }
          }
        }
        .project-body {
          flex: 1;
          height: calc(100% - 60px);
          .equity-card {
            height: 100%;
            .card-List {
              width: 100%;
              height: calc(100% - 57px);
              padding: 10px;
              overflow: auto;
              .list-none {
                height: 100%;
                text-align: center;
                padding-top: 100px;
              }
              .card-box {
                display: inline-block;
                vertical-align: middle;
                margin-right: 20px;
                margin-bottom: 20px;
                .card-action {
                  display: flex;
                  justify-content: space-between;
                  padding: 10px 50px;
                }
              }
              .card-item {
                width: 297px;
                height: 172px;
                border-radius: 20px;
                position: relative;
                & > span {
                  position: absolute;
                }
                button + & {
                  margin-top: 20px;
                }
                .card-bg {
                  top: 50%;
                  position: absolute;
                  left: -25%;
                  transform: translateY(-50%);
                }
                .card-name {
                  font-size: 22px;
                  font-weight: bold;
                  left: 20px;
                  top: 10px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 90%;
                }
                .price {
                  font-size: 22px;
                  color: #fff;
                  left: 20px;
                  top: 54px;
                }
                .discount {
                  font-size: 22px;
                  color: #fafafa;
                  top: 54px;
                  right: 20px;
                }
                .endtime {
                  font-size: 20px;
                  color: #fafafa;
                  left: 20px;
                  bottom: 20px;
                }
                .sale {
                  font-size: 20px;
                  color: #fafafa;
                  right: 20px;
                  bottom: 20px;
                }
              }
            }
            .tabs {
              display: block;
              border-bottom: 1px solid #ebedf0;
              padding: 10px 0;
              margin: 0 10px;
              .tabs-item {
                display: inline-block;
                height: 35px;
                line-height: 35px;
                text-align: center;
                margin-right: -1px;
                color: #909399;
                font-size: 14px;
                margin: 0 20px;
                cursor: pointer;
                &.active {
                  color: #409eff;
                  border-bottom: 2px solid #409eff;
                }
                &:hover:not(.active) {
                  color: #000;
                }
              }
            }
          }
          .vip-card-info {
            .card-item {
              width: 297px;
              height: 172px;
              border-radius: 20px;
              display: inline-block;
              vertical-align: middle;
              position: relative;
              margin-left: 20px;
              margin-top: 20px;
              box-shadow: -2px 8px 30px #afafaf;
              & > span {
                position: absolute;
              }
              button + & {
                margin-top: 20px;
              }
              .card-bg {
                top: 50%;
                position: absolute;
                left: -25%;
                transform: translateY(-50%);
              }
              .card-name {
                font-size: 20px;
                font-weight: bold;
                left: 20px;
                top: 20px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 90%;
              }
              .tips {
                font-size: 14px;
                color: #fafafa;
                left: 20px;
                top: 54px;
              }
              .discount {
                font-size: 30px;
                color: #fafafa;
                top: 54px;
                right: 20px;
              }
              .wallet {
                font-size: 16px;
                color: #fafafa;
                left: 20px;
                bottom: 20px;
              }
              .score {
                font-size: 16px;
                color: #fafafa;
                left: 60%;
                transform: translateX(-50%);
                bottom: 20px;
              }
            }
          }
          .service-content {
            width: 100%;
            height: 100%;
            .service-header {
              height: 50px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              padding: 0 10px;
              border-bottom: 1px solid #ebedf0;
              .input-search {
                width: 200px;
              }
            }
            .service-body {
              display: flex;
              height: calc(100% - 50px);
              .goods-classify-list {
                width: 120px;
                min-width: 120px;
                height: 100%;
                background: #f8f8f8;
                font-size: 12px;
                overflow-y: auto;
                li {
                  color: #666666;
                  padding-left: 20px;
                  height: 50px;
                  line-height: 50px;
                  border-bottom: 1px solid #eeeeee;
                  cursor: pointer;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  &.active {
                    background: #fff;
                  }
                }
              }
              .goods-list {
                flex: 1;
                .list {
                  height: 100%;
                  overflow: auto;
                  padding-bottom: 10px;
                  box-sizing: border-box;
                  &::-webkit-scrollbar {
                    display: none;
                  }
                  .el-badge {
                    margin: 20px 0px 0 20px;
                  }
                }
                .item {
                  position: relative;
                  width: 140px;
                  height: 198px;
                  border: 1px solid #dcdfe6;
                  border-radius: 4px;
                  box-sizing: border-box;
                  background: #f8f8f8;
                  .tag-list {
                    display: inline-block;
                    position: absolute;
                    left: -1px;
                    top: -5px;
                    & > span {
                      background: #ee3030;
                      color: #fff;
                      font-size: 12px;
                      border-radius: 3px;
                      padding: 0 5px;
                    }
                  }
                  .pic {
                    width: 100%;
                    height: 139px;
                    object-fit: cover;
                    border-top-left-radius: 4px;
                    border-top-right-radius: 4px;
                    background: #fff;
                  }
                  .info {
                    font-size: 14px;
                    line-height: 14px;
                    padding-left: 10px;
                    .title {
                      font-weight: bold;
                      margin-top: 9px;
                      color: #333333;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                    .price {
                      margin-top: 9px;
                      color: #ee3030;
                    }
                  }
                }
                .list-none {
                  text-align: center;
                  font-size: 14px;
                  color: #999999;
                  padding-top: 200px;
                  & > p {
                    margin: 10px 0;
                  }
                }
              }
            }
          }
        }
      }
      .order-action {
        flex: 1;
        min-width: 50%;
        height: 100%;
        border-left: 1px solid #eeeeee;
        position: relative;
        position: relative;
        .content-container {
          height: calc(100% - 220px);
          border-top: 0;
          position: relative;
          .recharge-form {
            padding: 20px;
            .recharge-item {
              display: flex;
              width: 50%;
              align-items: center;
              margin-bottom: 10px;
              .title-text {
                min-width: 100px;
                text-align: right;
              }
              .el-input {
                width: 200px;
              }
            }
            .activity-list {
              margin: 50px;
            }
          }
          &.mask {
            &::before {
              content: "";
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(50, 50, 51, 0.3);
              z-index: 2;
            }
          }
          .top {
            display: flex;
            width: 100%;
            padding: 0 20px;
            height: 50px;
            line-height: 50px;
            font-size: 14px;
            box-sizing: border-box;
            justify-content: space-between;
            .title {
              width: 100px;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          .product-list {
            height: calc(100% - 50px);
            overflow: auto;
            .item {
              margin: 0 16px 16px;
              background: #f7f8fa;
              border-radius: 4px;
              position: relative;
              padding: 0 32px 0 24px;
              .close {
                position: absolute;
                right: 10px;
                top: 10px;
                width: 20px;
                height: 20px;
                cursor: pointer;
              }
              .service-info {
                display: flex;
                justify-content: space-between;
                min-height: 92px;
                padding: 20px 0 16px 0;
                box-sizing: border-box;
                box-shadow: 0px 1px 0px 0px #ebedf0;
                .info {
                  width: 50%;
                  .name {
                    font-size: 18px;
                    font-weight: 500;
                    color: #323232;
                  }
                  .spec {
                    font-size: 14px;
                    color: #969799;
                  }
                }
                .num {
                  width: 29%;
                }
                .price {
                  width: 21%;
                  font-size: 20px;
                  font-weight: 500;
                  color: #323232;
                  line-height: 20px;
                  display: flex;
                  align-items: flex-end;
                  justify-items: flex-end;
                  flex-direction: column;
                  .total {
                    display: flex;
                    align-items: center;
                  }
                  .cp-btn {
                    margin-left: 10px;
                  }
                  .discount {
                    text-align: right;
                    height: 20px;
                    font-size: 14px;
                    font-weight: 500;
                    color: #fe2278;
                    .original {
                      color: #c7c7c7;
                      text-decoration: line-through;
                    }
                    .reduction {
                      margin-left: 6px;
                    }
                  }
                }
              }
              .service-personal {
                box-sizing: border-box;
                min-height: 72px;
                padding: 16px 0;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .nickname {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .add-personal {
          box-sizing: border-box;
          height: 30px;
          min-width: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          border: 1px dashed #c8c9cc;
          padding: 0 10px;
          cursor: pointer;
        }
        .footer {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          text-align: right;
          font-size: 12px;
          line-height: 12px;
          color: #333333;
          background: #fff;
          z-index: 2;
          .fold-container {
            padding: 0 20px;
            .title {
              font-size: 14px;
              line-height: 22px;
              height: 22px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 13px 0;
            }
            .content {
              padding: 16px;
              background: #f7f8fa;
              margin-bottom: 12px;
              .more-col {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .item {
                  // min-width: 50%;
                  flex: 1;
                }
              }
              .item {
                display: flex;
                align-items: flex-start;
                &.center {
                  justify-content: flex-start;
                  align-items: center;
                }
                .title-text {
                  font-size: 14px;
                  line-height: 32px;
                  margin-right: 6px;
                }
                .remarks-input {
                  flex: 1;
                }
                .el-switch {
                  & + .el-date-editor {
                    margin: 10px;
                  }
                }
                .hand-cards {
                  display: flex;
                  flex-wrap: wrap;
                  flex: 1;
                  align-items: flex-start;
                  .card {
                    margin: 0 10px 10px 0;
                  }
                  .el-input {
                    width: 80px;
                  }
                }
              }
            }
          }
          p {
            margin-top: 20px;
          }
          .remarks {
            margin-top: 12px;
            margin-bottom: 20px;
            color: #f57878;
          }
          .remarks-input {
            margin: 4px 0 12px 0;
          }
          .action-btn {
            display: flex;
            padding: 16px 20px;
            justify-content: space-between;
            align-items: center;
            border-top: 1px solid #eeeeee;
            .left {
              font-size: 18px;
              line-height: 1;
              display: flex;
              align-items: center;
              .price {
                font-size: 22px;
                font-weight: bold;
                color: #fe2278;
                vertical-align: middle;
              }
              .discount {
                font-size: 14px;
                color: #969799;
                margin: 0 15px;
              }
            }
          }
        }
      }
    }
  }
  .position-pop {
    position: fixed;
    z-index: 2;
    &.change-price {
      width: 300px;
      height: 120px;
      border-radius: 2px;
      box-shadow: 0 2px 8px 0 rgba(200, 201, 204, 50%);
      background-color: #fff;
      .pop-container {
        padding: 10px;
        .change-price-input-box {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .el-icon-sort {
            margin: 0 10px;
            transform: rotate(90deg);
          }
          .value-input {
            min-width: 120px;
          }
        }
        .tips {
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 12px;
          color: #969799;
        }
      }
    }
  }
  .popup {
    z-index: 1000;
  }
  .popup-container {
    padding: 20px;
    width: 1000px;
    height: 600px;
    background: #f8f8f8;
    .hanging-order-list {
      height: calc(100% - 70px);
      overflow: auto;
      .hanging-order-unpay {
        display: flex;
        flex-wrap: wrap;
        .item {
          background-color: #fff;
          min-width: 322px;
          margin-right: 10px;
          margin-bottom: 10px;
          padding: 10px 20px;
          box-sizing: border-box;
          .people {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 18px;
            text-align: center;
            line-height: 30px;
            height: 95px;
          }
          .order-info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            height: 112px;
            font-size: 14px;
            line-height: 30px;
            border-top: 1px dashed #dcdee0;
            border-bottom: 1px dashed #dcdee0;
            p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              span {
                color: #bbb;
              }
            }
          }
          .order-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 50px;
          }
        }
      }
      .hanging-order-hand {
        display: flex;
        flex-wrap: wrap;
        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 25px;
          min-width: 150px;
          height: 150px;
          margin-right: 10px;
          margin-bottom: 10px;
          background-color: #fff;
          cursor: pointer;
          color: #409eff;
        }
      }
    }
  }
}
</style>

<style lang="less">
.el-dropdown-menu {
  width: 150px;
}
.content-page {
  .goods-list {
    .el-table {
      .el-table__header {
        .cell {
          line-height: 26px;
        }
      }
      .el-checkbox__label {
        padding-left: 15px;
        vertical-align: middle;
      }
    }
  }
}
.tags-type {
  min-width: 136px !important;
  box-sizing: border-box;
  .el-button--mini {
    padding: 7px 12px;
  }
  .el-radio {
    margin-bottom: 14px;
  }
}
.btn-menu {
  height: 200px;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.num {
  .el-input-number {
    width: 100px;
    .el-input__inner {
      padding: 0 24px;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      width: 24px;
      box-sizing: border-box;
    }
  }
}
.order-dialog {
  .product-info {
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 20px;
    .pic {
      width: 80px;
      height: 80px;
      object-fit: cover;
    }
    .info {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      .title,
      .price {
        margin-top: 9px;
        font-size: 16px;
        line-height: 16px;
      }
      .title {
        color: #333333;
      }
      .price {
        color: #ee3030;
      }
      .stock-count {
        margin-top: 12px;
        font-size: 12px;
        color: #999999;
        line-height: 12px;
      }
    }
  }
  .dialog-content {
    .spec-list {
      .item {
        margin-bottom: 18px;
        .title {
          font-size: 14px;
          line-height: 14px;
          color: #333333;
          margin: 2px 0 10px 0;
          font-weight: bold;
        }
      }
      .el-checkbox.is-bordered + .el-checkbox.is-bordered {
        margin-left: 0;
      }
      .el-radio.is-bordered + .el-radio.is-bordered {
        margin-left: 0;
        margin-bottom: 20px;
      }
    }
  }
}
.sel-personal-dialog {
  .artisans-list {
    height: 300px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 10px 0;
    .item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: calc(50% - 20px);
      margin: 0 10px 10px 0;
      border: 1px solid #ebedf0;
      border-radius: 4px;
      height: 50px;
      padding: 10px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        background: #ecf5ff;
      }
      &.sel {
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
    }
  }
}
</style>
